import { Routes, Route } from "react-router";
import CashRequisitionList from "./List";
import CashRequisition from "./CashRequisition";


export default function CashRequisitions() {
   return <Routes>
      <Route path="/" element={<CashRequisitionList />} />
      <Route path="/:id" element={<CashRequisition />} />
   </Routes>
}